module.exports = __webpack_public_path__ + "static/media/event-mark.10e79af1.svg";